import { Card } from '@/components/ui/card';
import { IdentifiedSymptom } from '@repo/types/src/identified-symptom';
import { DeleteIdentifiedSymptom } from './DeleteIdentifiedSymptom';
import { EditIdentifiedSymptom } from './EditIdentifiedSymptom';

type IdentifiedSymptomCardProps = {
  item: IdentifiedSymptom;
  refetch: () => void;
};

export const IdentifiedSymptomCard = ({
  item,
  refetch,
}: IdentifiedSymptomCardProps) => {
  const sortedSupplements = [...item.foodSupplements].sort(
    (a, b) => a.orderNumber - b.orderNumber,
  );

  const linkCount = item.references
    .split(';')
    .filter((s) => s.trim().length > 0).length;

  return (
    <Card className="p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium text-zinc-500 uppercase">
          Symptômes ({item.symptoms.length})
        </p>
        <div className="flex gap-1 shrink-0">
          <EditIdentifiedSymptom item={item} refetch={refetch} />
          <DeleteIdentifiedSymptom item={item} refetch={refetch} />
        </div>
      </div>
      <div className="flex flex-wrap gap-1">
        {item.symptoms.map((s) => (
          <span
            key={s.id}
            className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full"
          >
            {s.symptom.type}
          </span>
        ))}
      </div>

      {sortedSupplements.length > 0 && (
        <div>
          <p className="text-xs font-medium text-zinc-500 uppercase mb-1">
            Compléments alimentaires ({sortedSupplements.length})
          </p>
          <ol className="flex flex-col gap-1">
            {sortedSupplements.map((fs) => (
              <li key={fs.id} className="flex items-center gap-2 text-sm">
                <span className="text-xs text-zinc-400 w-5 text-right shrink-0">
                  {fs.orderNumber}.
                </span>
                {fs.foodSupplement.image && (
                  <img
                    src={fs.foodSupplement.image}
                    alt={fs.foodSupplement.name}
                    className="w-6 h-6 rounded object-cover shrink-0"
                  />
                )}
                <span>{fs.foodSupplement.name}</span>
              </li>
            ))}
          </ol>
        </div>
      )}

      <div>
        <p className="text-xs font-medium text-zinc-500 uppercase mb-0.5">
          Références
        </p>
        <span className="text-sm">
          {linkCount} lien{linkCount > 1 ? 's' : ''}
        </span>
      </div>
    </Card>
  );
};
